import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BelenderRoutes } from 'src/app/belender/interfaces/belender-route.interface';
import { QuicklinkModule } from 'ngx-quicklink';
import { ExpirationDateComponent } from './expiration-date.component';

const routes: BelenderRoutes = [
  {
    path: '',
    component: ExpirationDateComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule, QuicklinkModule]
})
export class ExpirationDateRoutingModule {
}
